<template>
  <div class="text-center text-xs text-mgray2 mt-20 py-2">
    &copy; SEEN {{ new Date().getFullYear() }}
  </div>
</template>
